<template>
    <div class="main-content events-list events-view" v-cloak>
        <div class="container">
            <div
                class="events"
                style="padding-top:0"
                ref="scrollContainer"
                :style="{ height: `${events_list_container_height}px` }"
                v-if="active_tab === 'list'"
                id="events-list-container"
            >
                <infinite-loading
                    ref="infiniteLoading"
                    v-if="enable_list_loading"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="30"
                    direction="top"
                    @infinite="load_more_past_events"
                >
                </infinite-loading>

                <div v-for="(month_events, i) in events">
                    <event-group
                        :ref="'month_' + i"
                        :i="i"
                        :events="month_events"
                        :key="Object.keys(month_events).toString()"
                    ></event-group>
                </div>

                <infinite-loading
                    ref="infiniteLoadingDown"
                    v-if="enable_list_loading_down"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="30"
                    @infinite="load_more_future_events"
                >
                </infinite-loading>
            </div>

            <div v-else>
                <div
                    class="events-calendar"
                    :style="{ height: `${calendar_list_container_height}px` }"
                    ref="cal"
                    id="calendar-list-container"
                >
                    <infinite-loading
                        ref="infiniteCalLoading"
                        v-if="enable_cal_loading"
                        infinite-scroll-disabled="cal_busy"
                        infinite-scroll-distance="30"
                        direction="top"
                        @infinite="load_past_calendar_data"
                    >
                    </infinite-loading>
                    <calendar-group
                        v-for="(cal, i) in calendar_events"
                        :i="i"
                        :key="i + '-' + cal.start_date"
                        :calendar_group="cal"
                    >
                    </calendar-group>
                    <infinite-loading
                        ref="infiniteCalLoadingDown"
                        v-if="enable_cal_loading_down"
                        infinite-scroll-disabled="busy"
                        infinite-scroll-distance="30"
                        @infinite="load_future_calendar_data"
                    >
                    </infinite-loading>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapMutations, mapState } from "vuex";
import EventGroup from "./event-group";
import InfiniteLoading from "vue-infinite-loading";
import CalendarGroup from "./calendar-group";

export default {
    name: "events-page",
    components: {
        EventGroup,
        CalendarGroup,
        InfiniteLoading
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.get_logged_in_user();
            vm.clear_events();
            vm.set_active_tab("list");
            next();
        });
    },
    data() {
        return {
            busy: false,
            cal_busy: false,
            enable_list_loading: false,
            enable_cal_loading: false,
            enable_list_loading_down: false,
            enable_cal_loading_down: false,
            show_loader_up: false,
            show_loader_down: false,
            current_list_page: 0,
            current_min_calendar_page: 0,
            current_calendar_page: 0,
            current_list_min_page: 0,
            events_list_container_height: 0,
            calendar_list_container_height: 0
        };
    },
    watch: {
        active_tab: {
            handler: function(newVal, old_val) {
                if (old_val === "calendar" && newVal === "list") {
                    if (this.$refs.infiniteLoading) {
                        this.$refs.infiniteLoading.stateChanger.reset();
                        this.$refs.infiniteLoadingDown.stateChanger.reset();
                    }
                    this.scroll_to_current_month();
                }
                if (old_val === "list" && newVal === "calendar") {
                    if (this.$refs.infiniteCalLoading) {
                        this.$refs.infiniteCalLoading.stateChanger.reset();
                        this.$refs.infiniteCalLoadingDown.stateChanger.reset();
                    }
                    this.scroll_to_current_calendar();
                }
            },
            deep: true
        }
    },
    mounted() {
        this.clear_events();
        this.get_list_events(false);
        this.get_calendars_events(false);
        this.calculate_height();
    },
    created() {
        window.addEventListener("resize", this.resized);
    },
    computed: {
        ...mapState("StoreEvent", ["events"]),
        ...mapState("StoreEvent", ["calendar_events"]),
        ...mapState("StoreEvent", ["active_tab"]),
        layout() {
            return this.$screens({
                default: {
                    columns: 2,
                    rows: 2
                }
            });
        }
    },
    methods: {
        ...mapActions("StoreEvent", ["get_events", "add_more_events", "get_calendar_events"]),
        ...mapActions(["get_logged_in_user"]),
        ...mapMutations("StoreEvent", ["set_tab", "clear_events"]),
        resized() {
            this.calculate_height();
        },
        async get_list_events(current_page = false) {
            this.busy = true;
            let result = await this.get_events(current_page);
            if (result) {
                Vue.nextTick(() => {
                    if (current_page) {
                        //$containerElement.scrollTop = $currentElement.offsetTop;
                        this.busy = false;
                        if (current_page < 0) {
                            if (this.$refs.infiniteLoadingDown) {
                                this.$refs.infiniteLoadingDown.$emit("$InfiniteLoading:loaded");
                            }
                        } else {
                            if (this.$refs.infiniteLoading) {
                                this.$refs.infiniteLoading.$emit("$InfiniteLoading:loaded");
                            }
                        }
                    } else {
                        Vue.nextTick(() => {
                            this.scroll_to_current_month();
                            setTimeout(() => {
                                this.enable_list_loading = true;
                                this.enable_list_loading_down = true;
                            }, 500);
                            this.current_list_min_page = -3;
                            this.current_list_page = 3;
                        });
                    }
                });
            }
        },

        scroll_to_current_calendar() {
            Vue.nextTick(() => {
                if (document.getElementById("current-cal-item")) {
                    let $currentElement = document.getElementById("current-cal-item");
                    let $containerElement = this.$refs.cal;
                    if ($currentElement) {
                        $containerElement.scrollTop = $currentElement.offsetTop;
                    }
                }
            });
        },
        async get_calendars_events(current_page = false) {
            this.cal_busy = true;

            Vue.nextTick(() => {
                if (current_page) {
                    //$containerElement.scrollTop = $currentElement.offsetTop;
                    this.cal_busy = false;
                    if (current_page < 0) {
                        if (this.$refs.infiniteCalLoadingDown) {
                            this.$refs.infiniteCalLoadingDown.$emit("$InfiniteLoading:loaded");
                        }
                    } else {
                        if (this.$refs.infiniteCalLoading) {
                            this.$refs.infiniteCalLoading.$emit("$InfiniteLoading:loaded");
                        }
                    }
                } else {
                    Vue.nextTick(() => {
                        this.scroll_to_current_calendar();
                        setTimeout(() => {
                            this.enable_cal_loading = true;
                            this.enable_cal_loading_down = true;
                        }, 500);
                    });
                }
            });

            if (this.$refs.cal) {
                this.old_height = this.$refs.cal.scrollTop;
                this.old_scroll = this.$refs.cal.scrollHeight - this.$refs.cal.clientHeight;
            }

            let result = await this.get_calendar_events(current_page);
            if (result) {
                Vue.nextTick(() => {
                    if (current_page && current_page === 4) {
                        // after initial load to keep focus on current month
                        this.scroll_to_current_calendar();
                    }
                    if (current_page > 4) {
                        Vue.nextTick(() => {
                            let $containerElement = this.$refs.cal;
                            if ($containerElement) {
                                var newScroll = this.$refs.cal.scrollHeight - this.$refs.cal.clientHeight;
                                this.$refs.cal.scrollTop = this.old_height + (newScroll - this.old_scroll);
                            }
                        }, 500);
                    }
                });
            }
        },
        calculate_height() {
            Vue.nextTick(() => {
                this.events_list_container_height =
                    window.innerHeight - document.getElementById("main-menu").clientHeight - 140;
                if (
                    document.getElementById("mobile-menu") &&
                    document.getElementById("mobile-menu").style.display !== "none"
                ) {
                    this.events_list_container_height =
                        this.events_list_container_height -
                        document.getElementsByClassName("footer-mobile")[0].clientHeight;
                }
                this.calendar_list_container_height =
                    window.innerHeight - document.getElementById("main-menu").clientHeight - 51;
                if (
                    document.getElementById("mobile-menu") &&
                    document.getElementById("mobile-menu").style.display !== "none"
                ) {
                    this.calendar_list_container_height =
                        this.calendar_list_container_height -
                        document.getElementsByClassName("footer-mobile")[0].clientHeight;
                }
            });
        },
        scroll_to_current_month() {
            Vue.nextTick(() => {
                let $currentElement = document.getElementById("is-current");
                let $containerElement = this.$refs.scrollContainer;
                if ($currentElement) {
                    $containerElement.scrollTop = $currentElement.offsetTop;
                }
            });
        },
        scroll_cal(event) {
            //scrolled to the bottom
            if (event.target.scrollTop + event.target.offsetHeight >= event.target.scrollHeight - 140) {
                this.load_future_calendar_data();
            }
            // scrolled to the top
            if (event.target.scrollTop <= 100) {
                this.load_past_calendar_data();
            }
        },
        load_past_calendar_data() {
            this.show_loader_up = true;
            let timer;
            if (timer) {
                window.clearTimeout(timer);
            }
            timer = window.setTimeout(() => {
                this.current_calendar_page += 4;
                this.show_loader_up = false;
                this.get_calendars_events(this.current_calendar_page);
            }, 1000);
        },
        load_future_calendar_data() {
            this.show_loader_down = true;
            //console.log('loading more future data')
            let timer;
            if (timer) {
                window.clearTimeout(timer);
            }
            timer = window.setTimeout(() => {
                this.show_loader_down = false;
                this.current_min_calendar_page -= 4;
                this.get_calendars_events(this.current_min_calendar_page);
            }, 500);
        },
        set_active_tab(tab) {
            this.set_tab(tab);
        },

        load_more_past_events() {
            let timer;
            if (timer) {
                window.clearTimeout(timer);
            }
            timer = window.setTimeout(() => {
                this.current_list_page += 1;
                this.get_list_events(this.current_list_page);
            }, 1000);
        },
        load_more_future_events() {
            let timer;
            if (timer) {
                window.clearTimeout(timer);
            }
            timer = window.setTimeout(() => {
                this.current_list_min_page -= 1;
                this.get_list_events(this.current_list_min_page);
            }, 1000);
        }
    }
};
</script>

<style scoped>
.events {
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none;
    overflow-y: auto;
    height: 48vh;
    position: relative;
}

.events::-webkit-scrollbar {
    display: none;
}

[v-cloak] {
    display: none;
}
</style>
